module.exports = __webpack_public_path__ + "static/014-1be2eaf8250be886bf2d73072f2feda2.jpg";